export default "__VITE_ASSET__CfOVWPc7__"